import { OBJECT_TYPES_WITHOUT_SUB, COMMON_CUSTOMIZE_LABELS } from './constant';

export const convertToGroups = (
  productTypeCodes,
  comparedValue = 'parentProductTypeName',
  productTypeGroups = [],
  excludeResources = []
) => {
  if (Array.isArray(productTypeCodes)) {
    let groups = productTypeGroups.map((group) => {
      const name = group.productTypeCode.trim();
      let childItems = productTypeCodes.filter((code) => {
        return (
          code[comparedValue].toLowerCase() === name.toLowerCase() &&
          !excludeResources.includes(code.productTypeCode)
        );
      });

      if (childItems.length) {
        childItems = convertSubTypes(childItems, name, productTypeCodes, comparedValue);
      }

      return {
        value: name,
        text: name,
        icon: require(`@/assets/img/scmp/productType/${group.imgName}`),
        childItems
      };
    });
    return groups.filter((group) => group.childItems.length > 0);
  }
  return [];
};

export const convertSubTypes = (listItem, groupName, productTypeCodes, comparedValue) => {
  const result = [];
  for (let index = 0; index < listItem.length; index++) {
    const item = listItem[index];
    item.groupName = groupName;
    let childItems = productTypeCodes.filter(
      (code) => code[comparedValue].toLowerCase() === item.productTypeName.toLowerCase()
    );
    if (childItems.length) {
      childItems.map((e) => (e.groupName = groupName));
      result.push({
        value: item.value,
        text: item.text,
        childItems: childItems,
        isSub: true
      });
    } else {
      result.push(item);
    }
  }
  return result;
};

export const checkObjectTypesNonSub = (productType, objectType) => {
  return OBJECT_TYPES_WITHOUT_SUB.some(
    (item) => item.productTypes.includes(productType) && !item.objectTypes.includes(objectType)
  );
};
export const groupMetrics = (items = []) => {
  let groupedByObjectType = Object.groupBy(items, ({ objectType }) => objectType);

  for (const [key, value] of Object.entries(groupedByObjectType)) {
    const grouped = Object.groupBy(value, ({ metricSetName }) => metricSetName);
    if (key !== 'null') {
      groupedByObjectType[key] = grouped;
    } else {
      groupedByObjectType = grouped;
    }
  }
  return groupedByObjectType;
};

export const convertFlatMetricsToTree = (
  items = [],
  selected = [],
  needSetOrder = false,
  isPerformanceItemOfCustomCommon = false
) => {
  const metrics = groupMetrics(items);
  let values = [];
  let orderInMetric = 0;

  for (const [objectType, value] of Object.entries(metrics)) {
    let productTypeItems = [];
    let childItems = [];

    if (Array.isArray(value)) {
      childItems = value.map((item) => {
        const value = item.metricKey;
        const checkIndex = selected.findIndex(
          (i) => i.metricKey === value && i.objectType === item.objectType
        );

        item = { ...item, expand: false, check: checkIndex > -1 };

        return needSetOrder ? { ...item, orderInFlatMetrics: orderInMetric++ } : item;
      });

      productTypeItems = childItems;
    } else {
      for (const [productTargetType, items] of Object.entries(value)) {
        childItems = items.map((item) => {
          const value = item.metricKey;
          const checkIndex = selected.findIndex(
            (i) => i.metricKey === value && i.objectType === item.objectType
          );

          item = { ...item, expand: false, check: checkIndex > -1 };

          return needSetOrder ? { ...item, orderInFlatMetrics: orderInMetric++ } : item;
        });

        productTypeItems.push({
          text: productTargetType,
          value: productTargetType,
          childItems: childItems,
          expand: false
        });
      }
    }

    if (isPerformanceItemOfCustomCommon && !Array.isArray(value)) {
      values = productTypeItems;
      break;
    }

    values.push({
      text: Object.values(value)[0][0]
        ? Object.values(value)[0][0]['objectTypeNameEng']
        : value[0]['metricSetName'],
      value: objectType,
      expand: false,
      childItems: productTypeItems
    });
  }

  return values;
};

export const flatMetricsTree = (treeItems = [], needSetOrder = false) => {
  let results = [];

  for (const item of treeItems) {
    if (item.childItems) {
      results = results.concat(flatMetricsTree(item.childItems, needSetOrder));
    } else {
      if (needSetOrder) {
        results = results.concat({ ...item, orderInFlatMetrics: results.length });
      } else {
        results = results.concat(item);
      }
    }
  }

  return results;
};

/**
 * return an object in format like below
 * {
 *    productName: "attachmentName"
 *    dbversion: "version"
 * }
 * @param {*} productTypeCode
 */
export const getCustomLabels = (productTypeCode) => {
  const customLabels = {};
  const customItems = COMMON_CUSTOMIZE_LABELS[productTypeCode];

  if (customItems) {
    customItems.forEach((item) => Object.assign(customLabels, { [item.field]: item.tranKey }));
  }

  return customLabels;
};
